(function () {
  if (window.__stfLauf) return;
  window.__stfLauf = true;

  function stufen(b) {
    return Array.prototype.map.call(b.querySelectorAll('[data-stf-ab]'), function (s) {
      return { el: s, ab: +s.getAttribute('data-stf-ab') || 0, one: s.getAttribute('data-stf-one'), ad: s.getAttribute('data-stf-adapter') };
    }).sort(function (x, y) { return x.ab - y.ab; });
  }
  function setzen(b, n) {
    var r = b.querySelector('[data-stf-range]'), z = b.querySelector('[data-stf-zahl]');
    var max = r ? +r.max : 60;
    n = Math.max(1, Math.min(max, Math.round(n) || 1));
    if (r) r.value = n;
    if (z && document.activeElement !== z) z.value = n;
    var liste = stufen(b), an = null;
    liste.forEach(function (s) { if (n >= s.ab) an = s; });
    liste.forEach(function (s) { s.el.classList.toggle('stf__stufe--an', s === an); });
    b.classList.toggle('stf--gewaehlt', !!an);
    var e = b.querySelector('[data-stf-ergebnis]');
    if (!e) return;
    if (!an) {
      e.textContent = (b.getAttribute('data-t-unter') || '').replace('{anzahl}', liste.length ? liste[0].ab : '');
    } else {
      var art = b.getAttribute('data-stf-art') || 'one';
      e.textContent = (b.getAttribute('data-t-gilt-' + art) || '').replace('{anzahl}', n).replace('{pct}', art === 'adapter' ? an.ad : an.one);
    }
  }
  function alle() { document.querySelectorAll('[data-stf]').forEach(function (b) { var r = b.querySelector('[data-stf-range]'); setzen(b, r ? +r.value : 10); }); }

  document.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches) return;
    var b = t.closest('[data-stf]'); if (!b) return;
    if (t.matches('[data-stf-range]')) setzen(b, +t.value);
    else if (t.matches('[data-stf-zahl]')) { var v = parseInt(t.value, 10); if (v > 0) setzen(b, v); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-stf-zahl]')) return;
    var b = t.closest('[data-stf]'); var v = parseInt(t.value, 10);
    setzen(b, v > 0 ? v : 1); t.value = b.querySelector('[data-stf-range]').value;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-stf-zahl]')) e.target.blur();
  });
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('[data-stf-schritt]'); if (!s) return;
    var b = s.closest('[data-stf]'), r = b.querySelector('[data-stf-range]');
    setzen(b, (r ? +r.value : 10) + (+s.getAttribute('data-stf-schritt')));
  });
  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('[data-stf-wahl]'); if (!w) return;
    var b = w.closest('[data-stf]');
    b.setAttribute('data-stf-art', w.getAttribute('data-stf-wahl'));
    b.querySelectorAll('[data-stf-wahl]').forEach(function (x) { var an = x === w; x.classList.toggle('is-an', an); x.setAttribute('aria-pressed', an ? 'true' : 'false'); });
    var r = b.querySelector('[data-stf-range]'); setzen(b, r ? +r.value : 10);
    b.classList.remove('is-neu'); void b.offsetWidth; b.classList.add('is-neu');
  });
  document.addEventListener('click', function (e) {
    var st = e.target.closest && e.target.closest('[data-stf-ab]'); if (!st) return;
    setzen(st.closest('[data-stf]'), +st.getAttribute('data-stf-ab'));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();
